import { useCallback } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus, faCircleMinus } from '@fortawesome/free-solid-svg-icons'
import { useDropzone } from 'react-dropzone'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import {
  deleteImage,
  postOnDummyImage,
  selectBanner,
  selectLogo,
} from '@/store/imagesSlice'

export default function DropImages(props) {
  const { isLogo, isBanner, styleImage } = props
  const Logo = useSelector(selectLogo)
  const Banner = useSelector(selectBanner)
  const dispatch = useDispatch()

  const onDropImages = useCallback(async (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const formData = new FormData()
      acceptedFiles.forEach((item) => formData.append('file', item))
      if (isLogo) {
        dispatch(postOnDummyImage({ data: formData, type: 'logo' }))
      }
      if (isBanner) {
        dispatch(postOnDummyImage({ data: formData, type: 'banner' }))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg'],
    },
    maxSize: 400000,
    noKeyboard: true,
    multiple: false,
    onDrop: onDropImages,
  })
  const handleDelete = (e) => {
    e.stopPropagation()
    if (isLogo) {
      dispatch(deleteImage({ data: Logo.id, type: 'logo' }))
    }
    if (isBanner) {
      dispatch(deleteImage({ data: Banner.id, type: 'banner' }))
    }
  }

  return (
    <div className="group h-full w-full overflow-hidden rounded-md bg-white">
      {isLogo && (
        <span
          className={[
            Object.entries(Logo).length === 0
              ? 'h-full w-full bg-secondary'
              : 'h-0 w-0 bg-secondary/30 group-hover:h-full group-hover:w-full',
            'absolute left-1/2 top-1/2 z-40 flex -translate-x-1/2 -translate-y-1/2',
            'items-center justify-center gap-8 overflow-hidden rounded-full',
            'delay-0 duration-300 hover:delay-150',
          ].join(' ')}
        >
          <i {...getRootProps()}>
            <FontAwesomeIcon
              className={`z-20 h-8 w-8 cursor-pointer text-white hover:text-primary/95`}
              icon={faCirclePlus}
            />
          </i>

          {Object.entries(Logo).length !== 0 && (
            <FontAwesomeIcon
              className="z-20 mb-1 h-8 w-8 cursor-pointer text-white hover:text-primary/95"
              icon={faCircleMinus}
              onClick={handleDelete}
            />
          )}
        </span>
      )}
      {isBanner ? (
        <span
          className={[
            Object.entries(Banner).length === 0
              ? 'h-full w-full bg-secondary'
              : 'h-0 w-0 bg-secondary/30 group-hover:h-full group-hover:w-full',
            'absolute left-1/2 top-1/2 z-40 flex -translate-x-1/2 -translate-y-1/2',
            'items-center justify-center gap-12 overflow-hidden rounded-md',
            'delay-0 duration-300 hover:delay-150',
          ].join(' ')}
        >
          <i {...getRootProps()}>
            <FontAwesomeIcon
              className={`z-20 h-8 w-8 cursor-pointer text-white hover:text-primary/95`}
              icon={faCirclePlus}
            />
          </i>

          {Object.entries(Banner).length !== 0 && (
            <FontAwesomeIcon
              className="z-20 mb-1 h-8 w-8 cursor-pointer text-white hover:text-primary/95"
              icon={faCircleMinus}
              onClick={handleDelete}
            />
          )}
        </span>
      ) : (
        ''
      )}
      <input {...getInputProps()} />
      <img
        alt=""
        className={`${styleImage} h-full w-full object-cover ${
          isBanner && 'relative'
        }`}
        src={
          isBanner
            ? Banner.src === undefined || Banner.src === null
              ? ''
              : Banner.src
            : isLogo && (Logo.src === undefined || Logo.src === null)
              ? ''
              : Logo.src
        }
      />
    </div>
  )
}

DropImages.propTypes = {
  isLogo: PropTypes.bool,
  isBanner: PropTypes.bool,
  styleImage: PropTypes.string,
}

DropImages.defaultProps = {
  isLogo: false,
  isBanner: false,
  styleImage: '',
}
